import { Checkbox, Spin } from 'antd';
import { Link } from 'react-router';

import { SubmitWrapper } from '@style/pages/form.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Input } from '@atom/form/input/input';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';

import { initialResetPassword } from './reset-password.form-initial';
import { resetPasswordFormValidation } from './reset-password.form-validation';

export const ResetPasswordForm = ({ error, isLoading = false, form }: BaseFormInterface) => {
  const isAccepted = Form.useWatch('isAccepted', form);

  return (
    <Form form={form} initialValues={initialResetPassword} layout='vertical' name='reset'>
      <Form.Item label='Email' name='email' rules={[resetPasswordFormValidation]}>
        <Input placeholder='Ex: name@company.com' />
      </Form.Item>
      <Form.Item name='isAccepted' valuePropName='checked'>
        <Checkbox>
          <Text level='s'>
            Agree to the Terms and{' '}
            <Link target='_blank' to='https://velory.com/legal/privacy-policy'>
              Privacy Policy
            </Link>
            .
          </Text>
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <SubmitWrapper>
          <Button disabled={!isAccepted} htmlType='submit' type={ButtonTypeEnum.Primary} block>
            {isLoading && <Spin />}
            {!isLoading && (
              <Text color={ColorEnum.White} letterSpacing={1.4}>
                SEND LINK
              </Text>
            )}
          </Button>
        </SubmitWrapper>
      </Form.Item>
      <FormError error={error} errorField='email' />
    </Form>
  );
};
